export default __webpack_public_path__ + "static/media/service-rental-flow.290d4fd3.png";